import React, {Component } from 'react';
import Image from 'react-bootstrap/lib/Image';
import logo from './img/dash9-color-logo.png';
import p1 from './img/picture1.jpg';

class Banner extends Component {
  render() {
    return (
   <article className="slider">
    <div className="camera_wrap">
      <div data-src={p1}>
        <div className="camera-caption">
          <Image className="camera-caption" src={logo} />
        </div>
      </div>
    </div>
  </article>
    );
  }
}


export default Banner;


// WEBPACK FOOTER //
// ./src/Banner.js